// TODO: resolve cyclical dependencies
/* ============
 * Vuex Store
 * ============
 *
 * The store of the application.
 *
 * http://vuex.vuejs.org/en/index.html
 */

import { createLogger, createStore } from 'vuex'

import crmTierExperiment from '@/store/modules/crmTierExperiment'

import account from './modules/account'
import auth from './modules/auth'
import courses from './modules/courses'
import exercise from './modules/exercise'
// Modules
import general from './modules/general'
import language from './modules/language'
import materials from './modules/materials'
import modal from './modules/modal'
import notifications from './modules/notifications'
import offers from './modules/offers'

const debug = __ENVIRONMENT__ !== 'production'
const modules = {
  notifications,
  language,
  general,
  account,
  materials,
  modal,
  offers,
  auth,
  exercise,
  courses,
  crmTierExperiment
}

const store = createStore({
  /**
   * Assign the modules to the store.
   */
  modules,

  /**
   * If strict mode should be enabled.
   */
  strict: debug,

  /**
   * Plugins used in the store.
   */
  plugins: debug ? [createLogger()] : []
})

export default store
